/*
  Forms validation, and ajax submission.
*/

import Pristine from 'pristinejs';
import {
  contactDialog,
  dialogClass,
  dialogClassMail,
  dialogClassCall,
  initContactDialog
} from './dialog.js'

const dialogClassResult = `${dialogClass}--result`;
const phoneRegExp = /^((\+|00)[0-9]{1,3}[\. ])?([0-9][- ]?){4,14}(x.+)?$/;
const dialogContent = contactDialog.querySelector(`.${dialogClass}__content`)

async function post(form) {
  const data = {};

  for (const pair of new FormData(form)) {
    data[pair[0]] = pair[1];
  }

  const res = await fetch(form.action, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json'
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    body: JSON.stringify(data)
  });

  return res.json();
}

function validate(e) {
  const form = e.currentTarget;
  const input = e.target;

  if (!form.live) { return false }

  this.validate(input);
}

function bind(form) {
  let pristine = new Pristine(form, {}, false);

  form.querySelectorAll('[type=tel]').forEach(input => pristine.addValidator(input, value => phoneRegExp.test(value), input.dataset['pristineTelMessage'], 2, false));

  form.live = false;

  const liveValidate = validate.bind(pristine)
  form.addEventListener('input', liveValidate);
  form.addEventListener('change', liveValidate);

  function submit(e) {
    e.preventDefault();

    if (!form.live && !pristine.validate(null, true)) {
      form.live = true;
      pristine.validate()
    }

    if (!!pristine.getErrors().length) return false;

    post(form)
      .then(data => {
        if (data.status == 'sent') {
          contactDialog.classList.remove(dialogClassMail, dialogClassCall);
          contactDialog.classList.add(dialogClassResult);
          dialogContent.setAttribute('aria-labelledby', 'dialog-title-result');
          form.reset();
        }
        else if (data.status == 'exists') {
          const errorProfileExists = document.querySelector('.error-profil-exists');
          errorProfileExists.style.display = 'block';
        }
      });

  }

  form.addEventListener('submit', submit);
  initContactDialog.on('hide', () => {
    form.live = false;
    form.reset();
    pristine.reset();
  });

  return pristine;
}

const ajaxForm = () => {
  document.querySelectorAll('form#email-contact, form#phone-contact').forEach(bind);
};

export default ajaxForm;
